import filterByArraySchema from '../infrastructure/utils/filterByArraySchema';
import {
  ExploreConfiguration,
  exploreConfigurationSchema,
} from '../schemas/ExploreConfigurationSchema';

const parseExploreConfigurations = filterByArraySchema<ExploreConfiguration>(
  exploreConfigurationSchema
);

export default parseExploreConfigurations;
